import { createContext, FC, ReactNode, useContext } from 'react';
import { FeatureFlags } from '../types';

export interface IFeatureFlagsContext extends FeatureFlags {
  allowBAA?: boolean;
  allowMessaging?: boolean;
  disableConsolidatedAccounting?: boolean;
  removeScorecard?: boolean;
}

interface IFeatureFlagsContextProviderProps extends IFeatureFlagsContext, FeatureFlags {
  children?: ReactNode;
}
const FeatureFlagsContext = createContext<IFeatureFlagsContext>({
  clientGroups: false,
  allowEstateStatus: false,
  allowTargetScoreRanges: false,
  showElementDetailViewVideoThumbnails: true,
  showFutureIncome: true,
  showClientPersonalFinancialStatement: true,
  prospectDiscoveryAllDoneGoToDashboard: false,
  showTaskManagementSection: true,
  showClientSettings: false,
  showClientEditAccountButton: true,
  allowDocuments: true,
});

export const useFeatureFlagsContext = () => useContext(FeatureFlagsContext);

export const FeatureFlagsContextProvider: FC<IFeatureFlagsContextProviderProps> = ({ children, ...props }) => {
  return <FeatureFlagsContext.Provider value={props}>{children}</FeatureFlagsContext.Provider>;
};
